import Grid from '@mui/material/Grid'
import { Link as UnstyledLink } from 'react-router-dom'
import styled from 'styled-components'
import { useQueryClient } from 'react-query'

import { logout } from '../core/AccountProvider'
import navigate from '../core/navigate'
import UnstyledAccordionGrid from './AccordionGrid'
import UnstyledAccountBar from './AccountBar'

const AccountLink = styled(UnstyledLink)`
  display: block;
  background-color: #dcd7cf;
  color: #68504c;
  text-decoration: none;
  font-weight: bold;
  font-size: 12px;
  padding: 6px 10px;
  margin: 0;
  border-radius: 4px;
  transition: all 0.3s;
  text-align: left;

  :hover {
    background-color: #361611;
    color: white;
    outline: 0;
    text-decoration: none;
  }

  :focus {
    color: white;
    text-decoration: none;
  }
`

const AccountBar = styled(UnstyledAccountBar)`
  color: #333333;
`

const AccordionGrid = styled(UnstyledAccordionGrid)`
  position: fixed;
  top: 60px;
`
export default ({ expanded }) => {
  const client = useQueryClient();
  const handleLogout = () => {
    logout(client)
    if (window.location.pathname.includes('/account/', 0))
      navigate('/account/login')
    navigate(window.location.pathname)
  }

  return (
    <AccordionGrid expanded={expanded} direction='up'>
      <Grid item xs={12} sx={{ textAlign: 'left' }}>
        <AccountBar />
      </Grid>
      <Grid item xs={6}>
        <AccountLink 
          as='a' 
          id='account-accordion_bids' 
          href='/account/bids'
        >
          My Bids
        </AccountLink>
      </Grid>
      <Grid item xs={6}>
        <AccountLink
          as='a'
          id='account-accordion_settlement_instructions'
          href='/contract/spi'
        >
          My Settlement Instructions
        </AccountLink>
      </Grid>
      <Grid item xs={6}>
        <AccountLink
          as='a'
          id='account-accordion_watch_list'
          href='/account/watchlist'
        >
          My Watch List
        </AccountLink>
      </Grid>
      <Grid item xs={6}>
        <AccountLink 
          as='a' 
          id='account-accordion_profile' 
          href='/account/profile'
        >
          My Profile
        </AccountLink>
      </Grid>
      <Grid item xs={6}>
        <AccountLink
          as='a'
          id='account-accordion_saved_searches'
          href='/account/savedsearches'
        >
          My Saved Searches
        </AccountLink>
      </Grid>
      <Grid item xs={6}>
        <AccountLink
          as='a'
          id='account-accordion_communications'
          href='/account/communications'
        >
          My Communications
        </AccountLink>
      </Grid>
      <Grid item xs={6}>
        <AccountLink 
          as='a' 
          id='account-accordion_won' 
          href='/account/won'
        >
          My Won Items
        </AccountLink>
      </Grid>
      <Grid item xs={6}>
        <AccountLink
          as='a'
          id='account-accordion_recommendations'
          href='/search/recommendations'
        >
          My Recommendations
        </AccountLink>
      </Grid>
      <Grid item xs={6}>
        <AccountLink
          as='a'
          id='account-accordion_selling'
          href='/account/selling'
        >
          My Selling Items
        </AccountLink>
      </Grid>
      <Grid item xs={6}>
        <AccountLink
          as='a'
          id='account-accordion_logout'
          href=''
          onClick={handleLogout}
        >
          Logout
        </AccountLink>
      </Grid>
      <Grid item xs={6}>
        <AccountLink 
          as='a' 
          id='account-accordion_sold' 
          href='/account/sold'
        >
          My Sold Items
        </AccountLink>
      </Grid>
    </AccordionGrid>
  )
}
